import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function DefaultOption ( props ) {

    return <BasicCrudScreenType id="DefaultOption" table="DefaultOption" view="DefaultOption" noFilter />;

}

export default DefaultOption;
